import React from "react";
import { Chip, SearchChip } from "@sscs/ui";
import { TRANSFORM_EXPLOIT_FLAG } from "../../../../constants";
import styles from "./vullnerabilityTags.module.scss";
const VulnerabilityTags = ({ tags, onClick, }) => {
    const tagsWithoutTriaged = tags.filter((tag) => tag !== "TRIAGED");
    const hasTriaged = tags.includes("TRIAGED");
    return (React.createElement("div", { className: styles.tags },
        tagsWithoutTriaged.map((exploit) => (React.createElement(SearchChip, { key: exploit, label: TRANSFORM_EXPLOIT_FLAG[exploit], onClick: () => onClick(exploit) }))),
        hasTriaged && (React.createElement(Chip, { label: TRANSFORM_EXPLOIT_FLAG.TRIAGED, className: styles.triaged }))));
};
export default VulnerabilityTags;
//# sourceMappingURL=VulnerabilityTags.js.map